import { render } from "./StudioList.vue?vue&type=template&id=6599e012&scoped=true"
import script from "./StudioList.vue?vue&type=script&lang=js"
export * from "./StudioList.vue?vue&type=script&lang=js"

import "./StudioList.vue?vue&type=style&index=0&id=6599e012&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6599e012"]])

export default __exports__